import apiRequest from "../apiRequest";

const getMultiLanguageDatas = async (page) => {
  const token = process.env.NEXT_PUBLIC_API_TOKEN;
  try {
    const response = await apiRequest.get(
      `wordings?pagination[page]=${page}&pagination[pageSize]=100`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export {
  getMultiLanguageDatas,  
};
